import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

/* eslint-disable @typescript-eslint/typedef */
const routes: Routes = [
  {
    path: 'app',
    loadChildren: () =>
      import('./modules/companies-layout/companies-layout.module').then((m) => m.CompaniesLayoutModule),
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin-content/admin-content.module').then((m) => m.AdminContentModule),
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'tracking',
    loadChildren: () => import('./tracking/tracking.module').then((m) => m.TrackingContainerComponentModule),
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'app',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
